/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  background-color: #FFFFFF;
  background-color: var(--davinci-color-white, #FFFFFF);
  cursor: default;
  text-align: left;
  font-size: calc(12rem/14);
  line-height: calc(18rem/14);
}
:host .tag-slot {
  width: 100%;
}`;
export { style };
//# sourceMappingURL=TagModule.style.js.map